module.exports = __webpack_public_path__ + "img/wallet_02_yourgateway_1.ada39a94.png";